import { Stack } from '@findy-code/yuffie/ui/stack';
import type { ReactNode } from 'react';

import styles from './error.component.module.scss';

type Props = {
  statusCode: string;
  actions?: ReactNode;
  children: ReactNode;
};

export const ErrorComponent = ({ statusCode, actions, children }: Props) => {
  return (
    <Stack
      align="center"
      className={styles.container}
      justify="center"
      spacing="l"
    >
      <h1>{statusCode}</h1>
      {children && <div className={styles.errorBody}>{children}</div>}
      {actions && <div className={styles.actions}>{actions}</div>}
    </Stack>
  );
};
